export default "__VITE_ASSET__7d3ac667__"